import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Button, Card, CardContent, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth, api } from '../context/AuthContext';

const Dashboard = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [memorials, setMemorials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserMemorials = async () => {
      try {
        setLoading(true);
        console.log('Fetching user memorials...');
        
        const response = await api.get('/api/memorials/user/memorials');
        console.log('API Response:', response.data);
        
        if (response.data.success) {
          setMemorials(response.data.memorials || []);
        } else {
          console.error('API returned error:', response.data);
          setError('Server returned an error');
        }
      } catch (err) {
        console.error('Error fetching memorials:', err);
        setError(`Failed to load memorials: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (auth.isAuthenticated) {
      fetchUserMemorials();
    }
  }, [auth.isAuthenticated]);

  if (!auth.isAuthenticated) {
    navigate('/login');
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="h6" gutterBottom>
        Welcome, {auth.user?.name}
      </Typography>

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Your Memorials
        </Typography>
        
        {loading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box>
            <Typography color="error" gutterBottom>{error}</Typography>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => window.location.reload()}
            >
              Retry
            </Button>
          </Box>
        ) : memorials.length === 0 ? (
          <Box my={2}>
            <Typography variant="body1" gutterBottom>
              You haven't created any memorials yet.
            </Typography>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => navigate('/create-memorial')}
              sx={{ mt: 2 }}
            >
              Create Memorial
            </Button>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {memorials.map((memorial) => (
              <Grid item xs={12} sm={6} md={4} key={memorial._id}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {memorial.name}
                    </Typography>
                    <Typography color="text.secondary">
                      {new Date(memorial.dateOfBirth).toLocaleDateString()} - {new Date(memorial.dateOfDeath).toLocaleDateString()}
                    </Typography>
                    <Box mt={2}>
                      <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => navigate(`/memorial/${memorial._id}`)}
                        size="small"
                        sx={{ mr: 1 }}
                      >
                        View
                      </Button>
                      <Button 
                        variant="outlined" 
                        color="primary" 
                        onClick={() => navigate(`/edit-memorial/${memorial._id}`)}
                        size="small"
                      >
                        Edit
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
      
      <Box mt={4} display="flex" justifyContent="center">
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/create-memorial')}
        >
          Create New Memorial
        </Button>
      </Box>
    </Container>
  );
};

export default Dashboard;